import { ContentVariable } from 'components/learning-center/assignments/types';
import _ from 'lodash';

/**
 * Default content variables for use throughout the CMS.
 *
 * Takes the following shape:
 *
 * {
 *   companyName: '{{companyName}}',
 *   name: '{{name}}',
 *   assessmentScore: '{{assessmentScore}}',
 *   ...
 * }
 */
export const DEFAULT_CONTENT_VARIABLES: Record<ContentVariable, string> =
  _.reduce(
    ContentVariable,
    (acc, variable) => {
      acc[variable] = `{{${variable}}}`;
      return acc;
    },
    {} as Record<ContentVariable, string>
  );
